import { Pagination } from '@components/Pagination'
import { Button } from '@components/Buttons'
import { TabBody } from '@components/Tabs/components/TabBody'
import { PenNameSearchSelect } from '@features/profile/components/PenNameSearchSelect'
import { PenNameStoryList } from '@features/profile/components/PenNameStoryList'
import { Loading } from '@components/Loading'
import { NoBookIcon } from '@components/icons/NoBookIcon'
import { PlusIcon } from '@components/icons/PlusIcon'
import { ProfilePenNameProps } from './interface'

export function ProfilePenName({
  userId,
  penNameList,
  page,
  perpage,
  total,
  isLoading,
  isLoadingToggleBookLike,
  handlePaginationChange,
  handleSearchChange,
  handleAddPenName,
  handleEditPenName,
  handleDeletePenName,
  handleLikeBook,
}: ProfilePenNameProps) {
  return (
    <TabBody tabId='penName'>
      <div className='flex flex-col space-y-[20px] border-t border-gray-3 dark:border-purple'>
        <div className='flex mobile:flex-col justify-between items-center mt-[20px]'>
          <div className='w-[300px] mobile:w-full mobile:mb-[20px]'>
            <PenNameSearchSelect
              userId={userId}
              onSearch={handleSearchChange}
            />
          </div>
          {penNameList.length > 0 && (
            <Button
              type='button'
              className='bg-primary dark:bg-purple text-white dark:text-white-10 h-[40px] mobile:w-full'
              onClick={handleAddPenName}
            >
              <span className='text-[14px]'>เพิ่มนามปากกา</span>
            </Button>
          )}
        </div>
        {isLoading ? (
          <div className='flex justify-center'>
            <Loading />
          </div>
        ) : (
          <>
            {penNameList.length > 0 ? (
              <>
                <div className='flex flex-col space-y-[20px]'>
                  {penNameList.map(item => (
                    <PenNameStoryList
                      key={item.id}
                      books={item.books}
                      penName={item.firstPenName}
                      facebookLink={item.facebookLink}
                      twitterLink={item.twitterLink}
                      totalWriting={item.books.length}
                      totalBookmark={item.totalBookshelf}
                      totalReading={item.totalRead}
                      follower={item.totalFollower}
                      canEdit
                      canDelete
                      showBookStatus
                      isLoadingToggleBookLike={isLoadingToggleBookLike}
                      onEdit={() => handleEditPenName(item)}
                      onDelete={() => handleDeletePenName(item.id)}
                      onLikeBook={bookId => handleLikeBook(item.id, bookId)}
                    />
                  ))}
                </div>
                <Pagination
                  page={page}
                  perpage={perpage}
                  total={total}
                  pageChange={handlePaginationChange}
                />
              </>
            ) : (
              <div className='flex flex-col items-center justify-center pt-[40px]'>
                <NoBookIcon className='w-[120px] h-[119px] mb-[10px]' />
                <span className='font-mitr font-medium text-[18px] text-secondary-1 dark:text-dark-10 mb-[31px]'>
                  ไม่พบนามปากกา
                </span>
                <Button
                  type='button'
                  className='bg-primary dark:bg-purple text-white dark:text-white-2 h-[40px] mobile:w-full'
                  onClick={handleAddPenName}
                >
                  <PlusIcon className='mr-[5px]' />
                  <span className='text-[14px] font-medium'>เพิ่มนามปากกา</span>
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </TabBody>
  )
}
